<script>
  import List, { Item, Graphic, Meta, Text, PrimaryText, SecondaryText } from '@smui/list';
  import Button, { Label, Icon } from '@smui/button';
  import Stars from '$lib/client/shared/stars.svelte';
  import Breadcrumbs from '$lib/client/shared/breadcrumbs.svelte';
  import LayoutGrid, { Cell } from '@smui/layout-grid';
  import CompletedTrackItem from '$lib/client/shared/completed-track-item.svelte';
  import noImage from '$assets/no-artwork-grey-100x100.png';
  import { DateTime } from 'luxon';
  import { page } from '$app/stores';
  export let data;
  $: date = data.date;
  $: schedule = data.schedule;
  $: dayBefore = data.dayBefore;
  $: dayAfter = data.dayAfter;
  let selectionIndex;
</script>

<LayoutGrid class="u-p">
  <Cell span={12}>
    <Breadcrumbs />

    <h1>Schedule for {date}</h1>

    <List twoLine class="track-list" singleSelection selectedIndex={selectionIndex}>
      {#each schedule.tracks as track, trackIndex}
        <Item class="u-pr-none" key={track.id} on:SMUI:action={() => (selectionIndex = trackIndex)}>
          <CompletedTrackItem {track} artist={track.artist} scheduled_at={true} showBadges={true}>
            {#if trackIndex === selectionIndex}
              <Button class="u-ml-huge" tag="a" href="/artists/{track.artist.slug}"
                ><Label>View Profile</Label></Button
              >
            {/if}
          </CompletedTrackItem>
        </Item>
      {/each}
    </List>

    <nav class="pagination">
      {#if dayBefore}
        <Button tag="a" href="/music/{$page.params.slug}/schedules/{dayBefore}"
          ><Icon class="material-icons">navigate_before</Icon> <Label>{dayBefore}</Label></Button
        >
      {:else}
        <div />
      {/if}

      {#if dayAfter}
        <Button tag="a" href="/music/{$page.params.slug}/schedules/{dayAfter}">
          <Label>{dayAfter}</Label>
          <Icon class="material-icons">navigate_next</Icon></Button
        >
      {/if}
    </nav>
  </Cell>
</LayoutGrid>
